import React from "react";

import { useLanguage } from "@/contexts/LanguageContext.jsx";
import LegalDocumentPage from "@/pages/legal/LegalDocumentPage.jsx";
import { getDataDeletionSections, getLegalEffectiveDate } from "@/pages/legal/legalContent.js";

export default function DataDeletionPage() {
  const { t } = useLanguage();

  return (
    <LegalDocumentPage
      title={t("legal.dataDeletion.title", "Data Deletion Instructions")}
      subtitle={t(
        "legal.dataDeletion.subtitle",
        "How AfriMed™ users can request deletion of account-linked platform data, including identity verification, scope, and compliance-based retention exceptions.",
      )}
      effectiveDate={getLegalEffectiveDate(t)}
      sections={getDataDeletionSections(t)}
      siblingLink={{ to: "/legal/privacy", label: t("common.legal.privacy", "Privacy Policy") }}
      extraLinks={[{ to: "/legal/terms", label: t("common.legal.terms", "Terms & Conditions") }]}
    />
  );
}
